export default {
  // Componente visual - sem strings de texto estáticas traduzíveis
}
